<div class="studies-toggle">
  <mat-slide-toggle [(ngModel)]="isChecked" (change)="onChangeState($event.checked)">
    <span *ngIf="!isChecked">Ocultar estudios</span>
    <span *ngIf="isChecked">Ver estudios</span>
  </mat-slide-toggle>
</div>
